export const GET_MASS_PAYMENT_INVOICE_URL = '/api/v1/user/invoice/get-mass-pay'
export const CREATE_MASS_PAYMENT_INVOICE_URL = '/api/v1/user/invoice/create-mass-pay'
